<style lang="scss">
  #training {
    display: grid;
    grid-template-columns: minmax(auto, 370px) 1fr;
    max-height: calc(100vh - 200px);
    height: 100%;
    padding: 1.2rem;
    gap: 1.2rem;

    &.hideTaskGroups {
      display: grid;
      grid-template-columns: 1fr;
      margin: 0 auto;
      max-width: 1100px;
    }
  }
</style>

<script>
  import { onMount } from "@lifecycle";
  import confetti from "canvas-confetti";
  import { trainingHubTaskStore } from "../../../api-stores/training-hub-store";
  import Header from "./Header.svelte";
  import NotificationModal from "./NotificationModal.svelte";
  import {
    completionViewerSteps,
    firstNameStore,
    interactiveTasks,
    isVideoPlaying,
    onHashChange,
    welcomeSteps,
  } from "./stores";
  import TaskGroups from "./TaskGroups.svelte";
  import TasksSection from "./TasksSection.svelte";
  import VideoPreviewModal from "./VideoPreviewModal.svelte";

  onMount(async () =>
    trainingHubTaskStore.once().then((data) => {
      const current = data.tasks.find((t) => t.status === "current");
      if (current) interactiveTasks.setTask(current.taskId);
    }),
  );
  const { meta } = trainingHubTaskStore;

  $: ({ tasks, shownCompletionModal, shownWelcomeModal } =
    $trainingHubTaskStore);

  $: showWelcomeModal =
    $firstNameStore && $meta.firstFetchDone && !shownWelcomeModal;

  $: showCompletionViewerModal =
    $meta.firstFetchDone &&
    !shownCompletionModal &&
    tasks
      .filter((task) => !task.optional && !task.taskGroupOptional)
      .every((task) => task.status === "completed") &&
    !isVideoPlaying;

  $: hideTaskGroups = !$trainingHubTaskStore.taskGroups;

  const throwConfetti = () => {
    let count = 0;

    const launchConfetti = () => {
      const x = 0.25 + 0.5 * Math.random();
      const y = 0.25 + 0.5 * Math.random();

      confetti({
        particleCount: 75,
        startVelocity: 15,
        spread: 360,
        origin: { x, y },
        decay: 0.9,
        gravity: 0.3,
        zIndex: 1051,
      });

      count += 1;
      if (count < 10) setTimeout(launchConfetti, 200 + Math.random() * 500);
    };

    launchConfetti();
  };

  $: if (showCompletionViewerModal) throwConfetti();
</script>

<Header />
<main>
  <div id="training" class:hideTaskGroups>
    <TaskGroups />
    <TasksSection />
  </div>
</main>

<NotificationModal
  showModal={showWelcomeModal}
  modalSteps={$welcomeSteps}
  modalId="trainingWelcomeModal"
/>

<NotificationModal
  showModal={showCompletionViewerModal}
  modalSteps={completionViewerSteps}
  hideCloseButtonOnFirst={true}
  modalId="trainingCompletionModal"
/>

<VideoPreviewModal />

<svelte:window on:hashchange={onHashChange} />
